import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import { useStore } from "../stores/root-store-context";

interface CheckCompanyStatusProps {
  children: ReactNode;
}

const CheckCompanyStatus: React.FC<CheckCompanyStatusProps> = ({ children }) => {
  const { applicationStore } = useStore();

  if (applicationStore.company?.IsFrozen) {
    return <Navigate to={`/${applicationStore.company?.Tenant}/payment-and-tariffs`} />;
  }

  return <>{children}</>;
};

export default CheckCompanyStatus;
